<template>
  <!-- 新增付款申请 -->
  <zl-dialog class="zl-saas" title="付款申请" ref="dialog" width="700px" :close-on-click-modal="false">
    <el-form label-width="170px" :model="payForm" :rules="rules" ref="payForm">
      <el-form-item label="应付金额(元):" v-if="fromPage !== 'settlement'">
        <span>{{ yingFuMoney }}</span>
      </el-form-item>
      <el-form-item label="本次申请付款金额(元):" prop="applyMoney">
        <el-input v-model="payForm.applyMoney" style="width: 360px"></el-input>
        <span style="margin-left:15px">{{currencyCH}}</span>
      </el-form-item>
      <el-form-item label="备注:" prop="remark">
        <el-input v-model="payForm.remark" placeholder="可输入200字" rows="4" type="textarea" maxlength="200" style="width: 360px"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button size="small" type="primary" @click="save">保存</el-button>
      <el-button size="small" plain type="primary" @click="previewPayOrder">
        预览付款凭证
      </el-button>
      <el-button size="small" type="primary" @click="confirm">确认生成付款凭证</el-button>
    </template>
  </zl-dialog>
</template>
<script>
import store from '@/store'
import orderPayCertDialog from './orderPayCertDialog.vue'
export default {
  data() {
    return {
      orderId: '',
      defaultApplyMoney: 0,
      payForm: {
        applyMoney: '', // 本次申请付款金额
        remark: '' // 备注
      },
      rules: {
        applyMoney: [
          { required: true, message: '本次申请付款金额不能为空' },
          {
            // pattern: /^[0-9.]*$/,
            pattern: /^([1-9]\d*(\.\d*[1-9][0-9])?)|(0\.\d*[1-9][0-9])|(0\.\d*[1-9])$/,
            message: '必须为大于0的数字',
            trigger: 'blur'
          },
          {
            pattern: /^[0-9]+[.]?[0-9]{0,6}$/,
            message: `输入最多6位小数`,
            trigger: 'blur'
          }
        ]
      },
      currencyCH: '人民币',
      fromPage: '',
      accountId: '',
      id: '',
      type: '',
      yingFuMoney: ''
    }
  },
  methods: {
    open(args) {
      this.orderId = args.orderId
      this.id = args.id
      this.type = args.type
      this.fromPage = args.fromPage
      this.accountId = args.accountId
      this.yingFuMoney = args.yingFuMoney
      this.payForm.applyMoney = this.defaultApplyMoney = args.defaultApplyMoney
      if (args.currencyCH) {
        this.currencyCH = args.currencyCH
      }
      return this.$refs.dialog.open()
    },
    cancel() {
      this.$refs.dialog.cancel()
    },
    // 预览付款凭证
    previewPayOrder() {
      this.$zl.dialog.openFull(orderPayCertDialog, {
        orderId: this.orderId,
        applyMoney: this.payForm.applyMoney,
        isPreview: true
      }).then((res) => {
      })
    },
    save() {
      this.$refs.payForm.validate(valid => {
        if (valid) {
          this.submit('save')
        }
      })
    },
    submit(flag) {
      const data = {
        caoZuoType: flag === 'save' ? 0 : 1, // 0： 保存  1：确认生成付款凭证
        orderId: this.orderId,
        ...this.payForm
      }
      data.applyMoney = data.applyMoney * 1
      if (this.fromPage === 'settlement') {
        data.accountId = this.accountId
      }
      if (this.type === 'edit') {
        data.id = this.id
      }
      store.dispatch('confirmPaymentOrder', data).then(res => {
        this.$refs.dialog.close({ ...res, type: flag })
      })
    },
    confirm() {
      this.$refs.payForm.validate(valid => {
        if (valid) {
          /* if (Number(this.payForm.applyMoney) > Number(this.defaultApplyMoney)) {
            this.$zl.message.warn('累计申请付款金额和子单结算金额和超过订单预算，请检查!')
            return false
          } */
          this.$confirm('付款凭证打印之后，不可再修改付款金额，请确认是否继续打印凭证。', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.submit('confirm')
          }).catch(() => {
          })
        }
      })
    }
  }
}
</script>
